import HeaderHero from '../Components/Sections/HeaderHero';
import Services from '../Components/Sections/Services';
import RateSheets from '../Components/Sections/RateSheets';

import '../App.css';
import MailingList from "../Components/Sections/MailingList";

function HomePage() {
  return (
    <div className="homepage">
      <HeaderHero />
      <div className="body">
        <MailingList />
        <RateSheets />
        <Services />
      </div>
    </div>
  )
}

export default HomePage;

